import { GraphQLClient } from 'graphql-request';

export async function request({ query, variables, preview }) {
  let endpoint = "https://graphql.datocms.com";

  if (process.env.NEXT_DATOCMS_ENVIRONMENT) {
    endpoint += `/environments/${process.env.NEXT_DATOCMS_ENVIRONMENT}`;
  }

  if(preview) {
    endpoint += '/preview';
  }

  const client = new GraphQLClient(endpoint, {
    headers: {
      authorization: `Bearer ${process.env.NEXT_DATOCMS_API_TOKEN}`,
    },
  });

  return client.request(query, variables);
}

export function gqlStaticPaths(query, paramName, dataToParams) {
  return async () => {
    const { data } = await request({ query });

    return {
      fallback: 'blocking',
      paths: dataToParams(data).map((param) => ({
        params: {
          [paramName]: Array.isArray(param) ? param : param.toString(),
        },
      })),
    };
  };
}

export function hasContent(model) {
  try {
    model.content?.value?.document?.children[0]?.children[0]?.value;
  } catch(e) {
  return false
  }
}